<div class="trustpilot-widget"
     data-locale="en-GB"
     data-businessunit-id="54d390ca0000ff00057d38e7"
     [attr.id]="id"
     [attr.data-template-id]="templateId"
     [attr.data-style-width]="width"
     [attr.data-style-height]="height"
     [attr.data-theme]="theme">
  <a href="https://uk.trustpilot.com/review/www.yopa.co.uk" target="_blank" rel="noopener">Trustpilot</a>
</div>
